/* eslint-disable import/prefer-default-export */
export const MXP_FTC_GET_VISIT = 'MXP_FTC_GET_VISIT';
export const MXP_FTC_CHOSE_COLLATERAL_SOURCE = 'MXP_FTC_CHOSE_COLLATERAL_SOURCE';
export const MXP_FTC_REVIEW_VISIT = 'MXP_FTC_REVIEW_VISIT';
export const MXP_FTC_REVIEW_CONTINUE = 'MXP_FTC_REVIEW_CONTINUE';
export const MXP_FTC_REQUEST_VISIT = 'MXP_FTC_REQUEST_VISIT';
export const MXP_FTC_REQUEST_CONTINUE = 'MXP_FTC_REQUEST_CONTINUE';
export const MXP_FTC_REPAYMENT_VISIT = 'MXP_FTC_REPAYMENT_VISIT';
export const MXP_FTC_REPAYMENT_CONTINUE = 'MXP_FTC_REPAYMENT_CONTINUE';
